import React from 'react';
import Masonry from "react-masonry-component";
import { createGlobalStyle } from 'styled-components';
import AOS from 'aos';
AOS.init();

const GlobalStyles = createGlobalStyle`
    body.hide{
          overflow-y: hidden; /* Hide vertical scrollbar */
          overflow-x: hidden; /* Hide horizontal scrollbar */
        }
`;

const Gallery= function() {
    /* lightbox1 */
    const [lighbx, setlighbx] = React.useState(false);
    const handleBtnClick = (): void => {
      setlighbx(!lighbx);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
    };
    const handleBtnClickclose = (): void => {
      setlighbx(!lighbx);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "auto";
    };

    /* lightbox2 */
    const [lighbx1, setlighbx1] = React.useState(false);
    const handleBtnClick1 = (): void => {
      setlighbx1(!lighbx1);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
    };
    const handleBtnClickclose1 = (): void => {
      setlighbx1(!lighbx1);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "auto";
    };

    /* lightbox2 */
    const [lighbx2, setlighbx2] = React.useState(false);
    const handleBtnClick2 = (): void => {
      setlighbx2(!lighbx2);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
    };
    const handleBtnClickclose2 = (): void => {
      setlighbx2(!lighbx2);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "auto";
    };
    /* lightbox3 */
     const [lighbx3, setlighbx3] = React.useState(false);
      const handleBtnClick3 = (): void => {
      setlighbx3(!lighbx3);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
     };
     const handleBtnClickclose3 = (): void => {
       setlighbx3(!lighbx3);
      var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "auto";
     };
     /* lightbox4 */
     const [lighbx4, setlighbx4] = React.useState(false);
      const handleBtnClick4 = (): void => {
      setlighbx4(!lighbx4);
      var x = document.getElementsByTagName("BODY")[0];
      x.style.overflow = "hidden";
     };
     const handleBtnClickclose4 = (): void => {
       setlighbx4(!lighbx4);
      var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "auto";
     };
       /* lightbox5 */
       const [lighbx5, setlighbx5] = React.useState(false);
       const handleBtnClick5 = (): void => {
       setlighbx5(!lighbx5);
       var x = document.getElementsByTagName("BODY")[0];
       x.style.overflow = "hidden";
      };
      const handleBtnClickclose5 = (): void => {
        setlighbx5(!lighbx5);
       var x = document.getElementsByTagName("BODY")[0];
        x.style.overflow = "auto";
      };
    return(
            <div className="container">
            <GlobalStyles/>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h2>Portfolio</h2>
                        <div className="space-border"></div>
                    </div>
                </div>
                 <Masonry
                    className={"row my-gallery-class"} elementType={"div"}>
                    <div className="col-lg-4 image-element-class de_modal de_modal" onClick={handleBtnClick}
                        data-aos="fade-up"
                        data-aos-once="true"
                        >
                        <div className="card-image-1">
                            <div className="d-text">
                                <h3>ERP system</h3>
                                <h5 className="d-tag">management website</h5>
                            </div>
                            <img src="./img/background/r1.png" alt="gallery"/>
                        </div>
                    </div>
                    <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick3}
                        data-aos="fade-up"
                        data-aos-once="true"
                        > 
                        <div className="card-image-1">
                            <div className="d-text">
                                <h3>Ecommerce</h3>
                                <h5 className="d-tag">website</h5>
                            </div>
                            <img src="./img/background/e1.png" alt="gallery"/>
                        </div>
                    </div>
                    <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick1}
                        data-aos="fade-up"
                        data-aos-once="true"
                        >
                        <div className="card-image-1">
                            <div className="d-text">
                                <h3>batoor</h3>
                                <h5 className="d-tag">delivery website</h5>
                            </div>
                            <img src="./img/background/b1.png" alt="gallery"/>
                        </div>
                    </div>
                    <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick2}
                        data-aos="fade-up"
                        data-aos-once="true"
                        >
                        <div className="card-image-1">
                            <div className="d-text">
                                <h3>FLutter gold calculator</h3>
                                <h5 className="d-tag">Flutter app</h5>
                            </div>
                            <img src="./img/background/dj1.jpg" alt="gallery"/>
                        </div>
                    </div>
                    <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick4}
                        data-aos="fade-up"
                        data-aos-once="true"
                        >
                        <div className="card-image-1" style={{height:"50% !important"}}>
                            <div className="d-text">
                                <h3>Flutter Music player App</h3>
                                <h5 className="d-tag">Flutter hybrid app</h5>
                            </div>
                            <img className='w-50' src="./img/background/m2.jpg" alt="gallery"/>
                        </div>
                    </div>
                    <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick5}
                        data-aos="fade-up"
                        data-aos-once="true"
                        >
                        <div className="card-image-1">
                            <div className="d-text">
                                <h3>Flutter dji Drone Scanner App</h3>
                                <h5 className="d-tag">Flutter hybrid app</h5>
                            </div>
                            <img className='w-50' src="./img/background/d1.jpg" alt="gallery"/>
                        </div>
                    </div>
                  </Masonry>

                  {/* lightbox1 */}
                  {lighbx && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                        <div className="col-lg-8">
                                <div className="row g-4">
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r1.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r2.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r3.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r4.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r5.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r6.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r7.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r8.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r9.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r11.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r22.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r33.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r44.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r55.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r66.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r77.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r88.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r99.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r111.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r222.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r333.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r444.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r555.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r666.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r777.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r888.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r999.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r1111.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r2222.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r3333.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/r4444.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r5555.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r6666.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r7777.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/r98888.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    
                                </div>
                            </div>
                          
                            <div className="col-lg-4 de_project-info">
                                <h3>ERP System</h3>
                                <p>Management Portals for hr management and employee maanagement </p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span>Cyber sync technologies</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>Management portal</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2022</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.hrportan.cybersynctech.com" target="_blank" rel="noreferrer">www.hrportan.cybersynctech.com</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended for management of company"
                                    <span>Dawood israr</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}

                  {/* lightbox2 */}
                  {lighbx1 && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose1}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                            <div className="col-lg-8">
                                <div className="row g-4">
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/b1.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b2.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b3.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/b4.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b5.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b6.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b7.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b8.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 de_project-info">
                                <h3>Delivery Website in React</h3>
                                <p>Pakistan's first on demand delivery marketplace which delivers all kind of items at your doorstep</p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span>Batoor</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>Delivery</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2023</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.batoor.pk" target="_blank" rel="noreferrer">www.batoor.pk</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended for delivery website and Apps."
                                    <span>Dawood israr</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}

                {/* lightboxvideo */}
                {lighbx2 && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose2}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                            <div className="col-lg-4">
                                 {/* <video className="pop" controls autoPlay loop> */}
                                  {/* <source src="./video/local-video-2.mp4" type="video/mp4"/> */}
                                  {/* <source src="./video/local-video-2.mp4" type="video/mp4"/> */}
                                  {/* Your browser does not support the video tag. */}
                                {/* </video>  */}
                                {/* <img src="./img/background/dj1.jpg" alt="" className="img-fluid"/>
                                <img src="./img/background/dj2.jpg" alt="" className="img-fluid"/>
                                <img src="./img/background/dj3.jpg" alt="" className="img-fluid"/>
                                <img src="./img/background/dj4.jpg" alt="" className="img-fluid"/> */}
                                <div className="row g-4">
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/dj1.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/dj2.jpg"alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/dj3.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/dj4.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    
                                </div>
                            </div>

                            <div className="col-lg-4 de_project-info">
                                <h3>Flutter Gold calculator Native App</h3>
                                <p>Gold calculator for Gold selling shops for calculating latest price for selling and buying the gold by deducting price</p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span>Envato</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>Branding</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2020</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.envato.com" target="_blank" rel="noreferrer">www.envato.com</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended."
                                    <span>John Archi</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}

                   {/* lightbox3 */}
                   { lighbx3 && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose3}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                            <div className="col-lg-8">
                                <div className="row g-4">
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/e1.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/e2.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/e3.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-12 item">
                                        <img src="./img/background/e4.png" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                   
                                </div>
                            </div>

                            <div className="col-lg-4 de_project-info">
                                <h3>Jevellery Ecommerse website</h3>
                                <p></p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span>Local</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>Ecommerse</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2021</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.batoor.pk" target="_blank" rel="noreferrer">www.batoor.pk</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended for delivery website and Apps."
                                    <span>Dawood israr</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}
        {/* lightbox4 */}
        { lighbx4 && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose4}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                        <div className="col-lg-8">
                                <div className="row g-4">
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m1.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m2.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m3.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m4.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m5.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-4 item">
                                        <img src="./img/background/m6.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    {/* <div className="col-lg-6 item">
                                        <img src="./img/background/b7.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6 item">
                                        <img src="./img/background/b8.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div> */}
                                </div>
                            </div>

                            <div className="col-lg-4 de_project-info">
                                <h3>Flutter Hybrid Music App</h3>
                                <p></p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span>Local</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>Ecommerse</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2021</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.batoor.pk" target="_blank" rel="noreferrer">www.batoor.pk</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Flutter app for both android and ios and both for mp3 songs along with video player.Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended for delivery website and Apps."
                                    <span>Dawood israr</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}
                   {lighbx5 && ( 
                  <div className="LightboxGal">
                    <div className="closeGal">
                        <button className="button-close" onClick={handleBtnClickclose5}></button>
                    </div>
                    <div className="v-center w-100">
                      <div className="mainLightbox container">
                        <div className="row g-5">
                        <div className="col-lg-8">
                                <div className="row g-4">
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d11.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d22.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d33.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d44.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d55.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d66.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d77.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d88.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d99.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d111.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d222.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d333.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d1.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d2.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d3.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-3 item">
                                        <img src="./img/background/d4.jpg" alt="galleryimage" className="img-fluid"/>
                                    </div>
                                   
                                    
                                </div>
                            </div>
                          
                            <div className="col-lg-4 de_project-info">
                                <h3>Flutter dji Drone Scanner App</h3>
                                <p>Management Portals for hr management and employee maanagement </p>
                               
                                <div className="de_project-details">
                                    <div className="d-field">
                                        <i className="fa fa-user-o"></i>Client: <span></span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-file-text-o"></i>Type: <span>DJI scanner app</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-calendar-o"></i>Year: <span>2022</span>
                                    </div>
                                    <div className="d-field">
                                        <i className="fa fa-external-link"></i>Preview: <span><a href="https://www.hrportan.cybersynctech.com" target="_blank" rel="noreferrer">www.hrportan.cybersynctech.com</a></span>
                                    </div>
                                </div>
                                <div className="spacer-30"></div>
                                <blockquote>
                                    "Very well done theme. Versatile, extremely well coded, and gorgeous. That's a great combo. Highly recommended for management of company"
                                    <span>Dawood israr</span>
                                </blockquote>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}
      </div>
    );
}

export default Gallery;